import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { CustomHeader } from './CustomHeader';
import { CheckBoxRenderer } from './CheckBoxRenderer';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

export class DiffResult extends Component {
    constructor(props) {
        super(props);

        this.state = {
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMovable: true
            },
            detailedView: false,
            showDetailedView: this.props.showDetailedView,
            incScrapDeposit: false,
            frameworkComponents: {
                customHeader: CustomHeader,
                checkBoxRenderer: CheckBoxRenderer
            },
            columnTypes: {
                moneyColumn: {
                    headerClass: 'right-align',
                    cellStyle: { 'text-align': 'right' },
                    valueFormatter: params => {
                        return params.value != null ? new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 0 }).format(params.value) : 'N/A';
                    }
                },
                coloredMoneyColumn: {
                    headerClass: 'right-align',
                    cellStyle: { 'text-align': 'right' },
                    valueFormatter: params => {
                        return params.value != null ? new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 0 }).format(params.value) : 'N/A';
                    },
                    cellClass: params => {
                        return params.value < 0 ? 'winner' : (params.value > 0 ? 'looser' : '');
                    }
                },
                percentColumn: {
                    headerClass: 'right-align',
                    cellStyle: { 'text-align': 'right' },
                    valueFormatter: params => {
                        return params.value != null ? `${new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 1 }).format(params.value)} %` : 'N/A';
                    }
                },
                coloredPercentColumn: {
                    headerClass: 'right-align',
                    cellStyle: { 'text-align': 'right' },
                    valueFormatter: params => {
                        return params.value != null ? `${new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 1 }).format(params.value)} %` : 'N/A';
                    },
                    cellClass: params => {
                        return params.value < 0 ? 'winner' : (params.value > 0 ? 'looser' : '');
                    }
                },
                checkBoxColumn: {
                    headerClass: 'center-align',
                    cellStyle: { 'text-align': 'center' },
                    cellRenderer: 'checkBoxRenderer'
                }
            }
        }
    }

    componentDidUpdate() {
        this.autoSizeColumns();
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    getColumnDefs = () => {
        return [
            {
                headerName: '',
                headerClass: 'center-align',
                headerGroupComponent: 'customHeader',
                headerGroupComponentParams: {
                    detailedView: this.state.detailedView,
                    showDetailedView: this.state.showDetailedView,
                    incScrapDeposit: this.state.incScrapDeposit,
                    onDetailedViewToggle: this.handleDetailedViewToggle,
                    onScrapDepositToggle: this.handleScrapDepositToggle
                },
                children: [
                    {
                        headerName: this.props.variantName,
                        field: 'vehicleName',
                        autoSize: true
                    },
                    {
                        headerName: 'Energikilde',
                        field: 'energySource',
                        autoSize: true,
                        minWidth: 100
                    },
                    {
                        headerName: 'Plugin',
                        field: 'plugIn',
                        autoSize: true,
                        type: 'checkBoxColumn'
                    },
                    {
                        headerName: 'Karosseri',
                        field: 'chassis',
                        flex: 1,
                        minWidth: 90
                    },
                    {
                        headerName: 'Elrekkevidde',
                        field: 'range',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 100
                    },
                    {
                        headerName: 'Pris i dag',
                        field: 'price',
                        flex: 1,
                        type: 'moneyColumn',
                        minWidth: 90
                    },
                    {
                        headerName: 'Vrakpant',
                        field: 'newScrapDepositTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView || !this.state.incScrapDeposit,
                        minWidth: 75
                    }
                ]
            },
            {
                headerName: 'Avgift',
                headerClass: 'center-align',
                children: [
                    {
                        headerName: this.props.oldYear,
                        field: this.state.incScrapDeposit ? 'oldTaxIncSD' : 'oldTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: this.state.detailedView,
                        minWidth: 75
                    },
                    {
                        headerName: this.props.newYear,
                        field: this.state.incScrapDeposit ? 'newTaxIncSD' : 'newTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: this.state.detailedView,
                        minWidth: 75
                    },
                    {
                        headerName: this.props.showPercent ? 'Diff kr' : 'Diff',
                        field: this.state.incScrapDeposit ? 'taxDiffIncSDInKr' : 'taxDiffInKr',
                        flex: 1,
                        type: 'coloredMoneyColumn',
                        hide: this.state.detailedView,
                        minWidth: 75
                    },
                    {
                        headerName: 'Diff %',
                        field: this.state.incScrapDeposit ? 'taxDiffIncSDInPercent' : 'taxDiffInPercent',
                        flex: 1,
                        type: 'coloredPercentColumn',
                        hide: this.state.detailedView || !this.props.showPercent,
                        minWidth: 75
                    }
                ]
            },
            {
                headerName: 'CO2',
                headerClass: 'center-align',
                children: [
                    {
                        headerName: 'g/km',
                        headerClass: 'right-align',
                        field: 'cO2Emissions',
                        flex: 1,
                        cellStyle: { 'text-align': 'right' },
                        hide: !this.state.detailedView,
                        minWidth: 60
                    },
                    {
                        headerName: this.props.oldYear,
                        field: 'oldCO2Tax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 70
                    },
                    {
                        headerName: this.props.newYear,
                        field: 'newCO2Tax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 70
                    },
                    {
                        headerName: this.props.showPercent ? 'Diff kr' : 'Diff',
                        field: 'cO2TaxDiffInKr',
                        flex: 1,
                        type: 'coloredMoneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 70
                    },
                    {
                        headerName: 'Diff %',
                        field: 'cO2TaxDiffInPercent',
                        flex: 1,
                        type: 'coloredPercentColumn',
                        hide: !this.state.detailedView || !this.props.showPercent,
                        minWidth: 70
                    }
                ]
            },
            {
                headerName: 'NOx',
                headerClass: 'center-align',
                children: [
                    {
                        headerName: 'mg/km',
                        headerClass: 'right-align',
                        field: 'nOxEmissions',
                        flex: 1,
                        cellStyle: { 'text-align': 'right' },
                        hide: !this.state.detailedView,
                        minWidth: 60
                    },
                    {
                        headerName: this.props.oldYear,
                        field: 'oldNOxTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: this.props.newYear,
                        field: 'newNOxTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: this.props.showPercent ? 'Diff kr' : 'Diff',
                        field: 'nOxTaxDiffInKr',
                        flex: 1,
                        type: 'coloredMoneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: 'Diff %',
                        field: 'nOxTaxDiffInPercent',
                        flex: 1,
                        type: 'coloredPercentColumn',
                        hide: !this.state.detailedView || !this.props.showPercent,
                        minWidth: 65
                    }
                ]
            },
            {
                headerName: 'Vekt',
                headerClass: 'center-align',
                children: [
                    {
                        headerName: 'kg',
                        field: 'weight',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 60
                    },
                    {
                        headerName: this.props.oldYear,
                        field: 'oldWeightTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: this.props.newYear,
                        field: 'newWeightTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: this.props.showPercent ? 'Diff kr' : 'Diff',
                        field: 'weightTaxDiffInKr',
                        flex: 1,
                        type: 'coloredMoneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: 'Diff %',
                        field: 'weightTaxDiffInPercent',
                        flex: 1,
                        type: 'coloredPercentColumn',
                        hide: !this.state.detailedView || !this.props.showPercent,
                        minWidth: 65
                    }
                ]
            },
            {
                headerName: 'MVA',
                headerClass: 'center-align',
                children: [
                    {
                        headerName: this.props.oldYear,
                        field: 'oldMVAElectricTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: this.props.newYear,
                        field: 'newMVAElectricTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: this.props.showPercent ? 'Diff kr' : 'Diff',
                        field: 'mvaTaxDiffInKr',
                        flex: 1,
                        type: 'coloredMoneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 65
                    },
                    {
                        headerName: 'Diff %',
                        field: 'mvaTaxDiffInPercent',
                        flex: 1,
                        type: 'coloredPercentColumn',
                        hide: !this.state.detailedView || !this.props.showPercent,
                        minWidth: 65
                    }
                ]
            },
            {
                headerName: 'Samlet avgift',
                headerClass: 'center-align',
                children: [
                    {
                        headerName: this.props.oldYear,
                        field: this.state.incScrapDeposit ? 'oldTaxIncSD' : 'oldTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 75
                    },
                    {
                        headerName: this.props.newYear,
                        field: this.state.incScrapDeposit ? 'newTaxIncSD' : 'newTax',
                        flex: 1,
                        type: 'moneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 75
                    },
                    {
                        headerName: this.props.showPercent ? 'Diff kr' : 'Diff',
                        field: this.state.incScrapDeposit ? 'taxDiffIncSDInKr' : 'taxDiffInKr',
                        flex: 1,
                        type: 'coloredMoneyColumn',
                        hide: !this.state.detailedView,
                        minWidth: 75
                    },
                    {
                        headerName: 'Diff %',
                        field: this.state.incScrapDeposit ? 'taxDiffIncSDInPercent' : 'taxDiffInPercent',
                        flex: 1,
                        type: 'coloredPercentColumn',
                        hide: !this.state.detailedView || !this.props.showPercent,
                        minWidth: 75
                    }
                ]
            }
        ];
    }

    autoSizeColumns = () => {
        if (this.gridColumnApi) {
            var columnIds = [];

            this.gridColumnApi.getAllColumns().filter(function (column) {
                return column.colDef.autoSize !== undefined && column.colDef.autoSize === true;
            }).forEach(function (column) {
                columnIds.push(column.colId);
            });

            this.gridColumnApi.autoSizeColumns(columnIds, false);
        }
    }

    handleDetailedViewToggle = evt => {
        this.gridApi.refreshHeader();
        this.setState({ detailedView: evt.target.checked });
    }

    handleScrapDepositToggle = evt => {
        this.gridApi.refreshHeader();
        this.setState({ incScrapDeposit: evt.target.checked });
    }

    render() {
        return (
            <div className="ag-theme-alpine" style={{ height: '100%', width: '100%' }}>
                <AgGridReact
                    defaultColDef={this.state.defaultColDef}
                    columnDefs={this.getColumnDefs()}
                    columnTypes={this.state.columnTypes}
                    rowData={this.props.rowData}
                    onGridReady={this.onGridReady}
                    frameworkComponents={this.state.frameworkComponents}
                    headerHeight="38"
                    rowHeight="35" />
            </div>
        )
    }
}
